import AppButton from "@/components/AppButton.vue";
import BannerPwa from "@/components/BannerPwa.vue";
import BottomNavigation from "@/components/BottomNavigation.vue";
import ContactChoiceModal from "@/components/ContactChoiceModal.vue";
import ModalCodigo from "@/components/ModalCodigo.vue";
import NewsCarousel from "@/components/NewsCarousel.vue";
import Slidetify from "@/components/Slidetify.vue";
import { getApplicationUrl } from "@/config";
import HomeContainer from "@/containers/HomeContainer.vue";
import FCM from "@/ts/FCM";
import Util from "@/ts/Util";
import moment from "moment";
import { Component, Vue } from "vue-property-decorator";
import Request from "../ts/Request";

@Component({
  components: {
    BottomNavigation,
    AppButton,
    ModalCodigo,
    Slidetify,
    BannerPwa,
    HomeContainer,
    NewsCarousel,
    ContactChoiceModal,
  },
})
export default class HomeRelease extends Vue {
  componentKey = 0;
  userData: any = JSON.parse(sessionStorage.getItem("USER_DATA") || "[]");
  stores: any = JSON.parse(sessionStorage.getItem("stores") || "[]") || [];
  organizationData: any =
    JSON.parse(sessionStorage.getItem("ORGANIZATION_DATA") || "{}") || {};
  notificationsKey = 1;
  homeNews: any[] =
    JSON.parse(sessionStorage.getItem("LAST_NEWS") || "[]") || [];
  lastScrollPosition = 0;
  logo: string = this.organizationData.CONFIGURATIONS.LOGO_IMAGE;
  otherButton: any = [
    {
      name: "notification",
      iconClass: "fal",
      icon: "bell",
      colorClass: "default",
      notification: 0,
      callback: this.goToNotifications,
    },
  ];

  modalMsg = "";
  openModal = false;
  items: any = [
    {
      route: "Lojas",
      name: "Delivery",
    },
    {
      route: "Lojas",
      name: "Retirar no Local",
    },
    {
      route: "Lojas",
      name: "Entrega Interna",
    },
    {
      route: "QrcodeReader",
      name: "Estou na Loja",
    },
    {
      route: "SupportRequest",
      name: "Fale Conosco",
    },
  ];
  selected: any = [];
  loadedNews: boolean = sessionStorage.getItem("LAST_NEWS") ? true : false;
  loadedItems: boolean = sessionStorage.getItem("LAST_NEWS") ? true : false;
  showSectionBanner = true;
  hasDelivery = false;
  hasBalcony = false;
  hasInternalDelivery = false;
  showModalLogoff = false;
  showContactModal = false;
  storeContact: any = {};

  created() {
    Util.removeTableData();
    sessionStorage.setItem("HAS_HOME", "true");
    if (!sessionStorage.getItem("BOTTOM_NAV_OPTIONS")) {
      const bottomNavOptions: any = [
        {
          id: "btn0",
          name: "Início",
          icon: "home-alt",
          active: false,
          route: "/HomeRelease",
          notification: 0,
        },
        {
          id: "btn1",
          name: "Comprar",
          icon: "store",
          active: false,
          route: "/Explorar",
          notification: 0,
        },
        {
          id: "btn2",
          name: "Carteira",
          icon: "wallet",
          active: false,
          route: "/Carteira",
          notification: 0,
        },
        {
          id: "btn3",
          name: "Compras",
          icon: "bags-shopping",
          active: false,
          route: "/PedidosRealizados",
          notification: 0,
        },
        {
          id: "btn4",
          name: "Perfil",
          icon: "user",
          active: false,
          route: "/Perfil",
          notification: 0,
        },
      ];
      sessionStorage.setItem(
        "BOTTOM_NAV_OPTIONS",
        JSON.stringify(bottomNavOptions)
      );
    }
  }

  beforeDestroy() {
    sessionStorage.setItem(
      "LAST_HOME_POSITION",
      JSON.stringify(this.lastScrollPosition)
    );
  }

  mounted() {
    const bn: any = BottomNavigation;
    const sn: any = Slidetify;
    bn.refresh();
    sn.refresh();

    const openModalLogOff = sessionStorage.getItem("openModalLogOff") || "F";
    openModalLogOff === "T" ? (this.showModalLogoff = true) : false;

    this.getStores();
    this.getNews();

    Util.setBackButtonBehavior(() => {});

    const lastGetNotifications: any = sessionStorage.getItem(
      "LAST_GET_NOTIFICATIONS"
    )
      ? sessionStorage.getItem("LAST_GET_NOTIFICATIONS")
      : null;
    const duration: any = lastGetNotifications
      ? moment.duration(moment().diff(lastGetNotifications))
      : null;
    const diffTime: number = duration ? duration._data.hours : 0;

    if (diffTime >= 0 && sessionStorage.getItem("USER_ID")) {
      Util.getUserNotifications((response: any) => {
        let currentNotifications: any = [];

        if (response.length > 0) {
          currentNotifications = response;
          const oldNotificationsStorage: any = JSON.parse(
            sessionStorage.getItem("OLD_NOTIFICATIONS") || "[]"
          );
          const newNotifications =
            currentNotifications.filter(
              (objeto: any) =>
                !oldNotificationsStorage.find(
                  (obj2: any) => obj2.id == objeto.id
                )
            ) || [];
          if (currentNotifications) {
            if (newNotifications.length && newNotifications[0].status == "P") {
              sessionStorage.setItem(
                "USER_HAS_NOTIFICATIONS",
                JSON.stringify(true)
              );
              this.otherButton.find(
                (obj: any) => obj.name == "notification"
              ).notification = newNotifications.length;
            } else {
              sessionStorage.setItem(
                "USER_HAS_NOTIFICATIONS",
                JSON.stringify(false)
              );
              this.otherButton.find(
                (obj: any) => obj.name == "notification"
              ).notification = 0;
            }
          }

          sessionStorage.setItem(
            "CURRENT_NOTIFICATIONS",
            JSON.stringify(currentNotifications)
          );
          this.notificationsKey++;
        } else {
          currentNotifications = [];
          sessionStorage.setItem(
            "USER_HAS_NOTIFICATIONS",
            JSON.stringify(false)
          );
          sessionStorage.setItem(
            "CURRENT_NOTIFICATIONS",
            JSON.stringify(currentNotifications)
          );
          this.notificationsKey++;
        }
      });
    }
    this.initFCM();
    sessionStorage.setItem("PARENT_EVENT", "");
    sessionStorage.setItem("EVENT_SCHEDULE_CACHE", "");
    this.goBackToLastScroll();
  }

  openLogOut() {
    this.modalMsg = "Você realmente deseja sair da sua conta?";
    this.openModal = true;
  }

  logOff() {
    Util.logOff();
  }

  cancelLogoff() {
    this.openModal = false;
    Util.cancelLogoff();
  }

  getStores() {
    try {
      const req = new Request();
      req.body = {
        NRORG: this.organizationData.NRORG,
        STRUCTURE_ID: sessionStorage.getItem("STRUCTURE_ID"),
        LATITUDE: sessionStorage.getItem("LATITUDE"),
        LONGITUDE: sessionStorage.getItem("LONGITUDE"),
        DEVICE_TIME: Util.getDeviceTime(),
        URL: getApplicationUrl(),
      };
      req.route = "getStoresNearUser";
      req.callbackSuccess = (response: any) => {
        const stores = response.stores;
        this.prepareStores(stores);
        this.checkDeliveryMethods(stores);
        this.$forceUpdate();
      };
      req.callbackError = function (error: any) {
        console.log(error);
      };
      req.blockTouchEvents = false;
      req.showLoader = false;
      req.send();
    } catch (e) {
      console.log(e);
    }
  }

  prepareStores(stores: any) {
    stores.forEach((store: any) => {
      if (
        !store.deliversToTable &&
        !store.deliversToBalcony &&
        !store.deliversToInternalLocation &&
        !store.deliversToAddress
      )
        store.opened = false;
    });

    const openedStores = stores.filter((s: any) => s.opened == true);
    const closedStores = stores.filter((s: any) => s.opened == false);

    stores = openedStores.concat(closedStores);

    this.stores = stores;
    sessionStorage.setItem("stores", JSON.stringify(this.stores));
  }

  getNews() {
    try {
      const req = new Request();
      req.body = {
        NRORG: this.organizationData.NRORG,
        MAX_RESULTS: 4,
        TOKEN: sessionStorage.getItem("TOKEN"),
      };
      req.route = "getLastNews";
      req.callbackSuccess = (response: any) => {
        sessionStorage.setItem("LAST_NEWS", JSON.stringify(response.news));
        this.homeNews = response.news;
        this.loadedNews = true;
        this.loadedItems = true;
        if (!this.homeNews.length) {
          this.showSectionBanner = false;
        }
      };
      req.callbackError = function (error: any) {
        console.log(error);
      };
      req.blockTouchEvents = false;
      req.showLoader = false;
      req.send();
    } catch (e) {
      console.log(e);
    }
  }

  setNewsDetails(ID: any, index: number) {
    sessionStorage.setItem(
      "NEWS_DETAIL",
      JSON.stringify(this.homeNews.find((news: any) => news.ID == ID))
    );
    sessionStorage.setItem("CURRENT_NEWS_INDEX", String(index));
    this.$router.push({ name: "NewsDetails" });
  }

  goToNotifications() {
    this.$router.push("Notifications");
  }

  initFCM() {
    new FCM().init(
      Util.onNewFCMToken,
      this.onPushOrderTapped,
      this.forceRerender
    );
  }

  forceRerender(data: any) {
    Util.getUserNotifications((response: any) => {
      let currentNotifications: any = [];

      if (response.length > 0) {
        currentNotifications = response;
        const oldNotificationsStorage: any = JSON.parse(
          sessionStorage.getItem("OLD_NOTIFICATIONS") || "[]"
        );
        const newNotifications =
          currentNotifications.filter(
            (objeto: any) =>
              !oldNotificationsStorage.find((obj2: any) => obj2.id == objeto.id)
          ) || [];
        if (currentNotifications) {
          if (newNotifications.length && newNotifications[0].status == "P") {
            sessionStorage.setItem(
              "USER_HAS_NOTIFICATIONS",
              JSON.stringify(true)
            );
            this.otherButton.find(
              (obj: any) => obj.name == "notification"
            ).notification = newNotifications.length;
          } else {
            sessionStorage.setItem(
              "USER_HAS_NOTIFICATIONS",
              JSON.stringify(false)
            );
            this.otherButton.find(
              (obj: any) => obj.name == "notification"
            ).notification = 0;
          }
        }

        sessionStorage.setItem(
          "CURRENT_NOTIFICATIONS",
          JSON.stringify(currentNotifications)
        );
        this.notificationsKey++;
      } else {
        currentNotifications = [];
        sessionStorage.setItem("USER_HAS_NOTIFICATIONS", JSON.stringify(false));
        sessionStorage.setItem(
          "CURRENT_NOTIFICATIONS",
          JSON.stringify(currentNotifications)
        );
        this.notificationsKey++;
      }
      this.$forceUpdate();
    });
  }

  goBackToLastScroll() {
    const element = <HTMLElement>this.$refs.bannerContainer;
    if (sessionStorage.getItem("LAST_HOME_POSITION")) {
      this.lastScrollPosition = Number(
        sessionStorage.getItem("LAST_HOME_POSITION")
      );
    }
    if (element) element.scrollTop = this.lastScrollPosition;
  }

  onPushOrderTapped(data: any) {}

  handlePushAddress() {
    sessionStorage.setItem("ENTERED_ADD_ADDRESS_FROM", "Home");
    this.$router.push("AddAddress");
  }

  goRouter(router: any, name: any) {
    const latitude: number | null =
      Number(sessionStorage.getItem("LATITUDE")) || null;
    const userId: number | null =
      Number(sessionStorage.getItem("USER_ID")) || null;
    const userData: any = JSON.parse(
      sessionStorage.getItem("USER_DATA") || "{}"
    );

    if (name == "Delivery") {
      sessionStorage.setItem("GO_TO_STORE", "true");
      sessionStorage.setItem("DELIVER_AT", "A");
      sessionStorage.setItem("SHOPPING", "delivery");
      sessionStorage.setItem("CAME_FROM_QRCODE", JSON.stringify(false));
      sessionStorage.setItem("CAME_FROM_RELEASE", "true");

      if (sessionStorage.getItem("USER_ID") != "") {
        sessionStorage.setItem("LOGADO", "true");
      }

      if (latitude === null) {
        if (userId === null) {
          this.handlePushAddress();
        } else if (userData.ADDRESS.length > 0) {
          sessionStorage.setItem("LATITUDE", userData.ADDRESS[0].LATITUDE);
          sessionStorage.setItem("LONGITUDE", userData.ADDRESS[0].LONGITUDE);
          this.$router.push(router);
        } else {
          this.handlePushAddress();
        }
      } else {
        if (userId !== null) {
          if (userData.ADDRESS.length > 0) {
            sessionStorage.setItem("LATITUDE", userData.ADDRESS[0].LATITUDE);
            sessionStorage.setItem("LONGITUDE", userData.ADDRESS[0].LONGITUDE);
          }
        }
        this.$router.push(router);
      }
    } else if (name == "Retirar no Local") {
      sessionStorage.setItem("BALCONY", "true");
      sessionStorage.setItem("GO_TO_STORE", "false");
      sessionStorage.setItem("DELIVER_AT", "B");
      sessionStorage.setItem("CAME_FROM_RELEASE", "true");
      sessionStorage.setItem("SHOPPING", "balcony");

      if (latitude === null) {
        if (userData.ADDRESS && userData.ADDRESS.length > 0) {
          sessionStorage.setItem("LATITUDE", userData.ADDRESS[0].LATITUDE);
          sessionStorage.setItem("LONGITUDE", userData.ADDRESS[0].LONGITUDE);
          this.$router.push(router);
        } else {
          this.handlePushAddress();
        }
      } else if (
        sessionStorage.getItem("USE_CURRENT_LOCATION") ||
        sessionStorage.getItem("PROVISORY_ADDRESS")
      ) {
        if (userId !== null) {
          if (userData.ADDRESS.length > 0) {
            sessionStorage.setItem("LATITUDE", userData.ADDRESS[0].LATITUDE);
            sessionStorage.setItem("LONGITUDE", userData.ADDRESS[0].LONGITUDE);
          }
          this.$router.push(router);
        } else {
          this.handlePushAddress();
        }
      } else {
        this.$router.push("Lojas");
      }
    } else if (name == "Entrega Interna") {
      sessionStorage.setItem("GO_TO_STORE", "false");
      sessionStorage.setItem("DELIVER_AT", "I");
      sessionStorage.setItem("CAME_FROM_RELEASE", "true");
      sessionStorage.setItem("SHOPPING", "internalLocation");
      sessionStorage.setItem("FIRST_SELECTION_INTERNAL_DELIVERY", "true");

      if (latitude === null) {
        if (userData.ADDRESS && userData.ADDRESS.length > 0) {
          sessionStorage.setItem("LATITUDE", userData.ADDRESS[0].LATITUDE);
          sessionStorage.setItem("LONGITUDE", userData.ADDRESS[0].LONGITUDE);
          this.$router.push(router);
        } else {
          this.$router.push(router);
        }
      } else if (
        sessionStorage.getItem("USE_CURRENT_LOCATION") ||
        sessionStorage.getItem("PROVISORY_ADDRESS")
      ) {
        if (userId !== null) {
          if (userData.ADDRESS.length > 0) {
            sessionStorage.setItem("LATITUDE", userData.ADDRESS[0].LATITUDE);
            sessionStorage.setItem("LONGITUDE", userData.ADDRESS[0].LONGITUDE);
          }
          this.$router.push(router);
        } else {
          this.$router.push("Lojas");
        }
      } else {
        this.$router.push("Lojas");
      }
    } else if (router == "QrcodeReader") {
      sessionStorage.setItem("CAME_FROM_RELEASE", "true");
      sessionStorage.setItem("DELIVER_AT", "T");
      if (window.cordova) {
        this.$router.push("QrcodeReaderApp");
      } else {
        this.$router.push("QrcodeReader");
      }
    } else if (router == "SupportRequest") {
      this.showContactModal = true;
    } else this.$router.push(router);
  }

  checkDeliveryMethods(stores: any) {
    this.hasDelivery = stores.find(
      (store: any) => store.deliversToAddress == true
    );
    this.hasBalcony = stores.find(
      (store: any) => store.deliversToBalcony == true
    );
    this.hasInternalDelivery = stores.find(
      (store: any) => store.deliversToInternalLocation == true
    );

    if (this.hasDelivery != undefined) this.hasDelivery = true;
    else this.hasDelivery = false;

    if (this.hasBalcony != undefined) this.hasBalcony = true;
    else this.hasBalcony = false;

    if (this.hasInternalDelivery != undefined) this.hasInternalDelivery = true;
    else this.hasInternalDelivery = false;

    this.items = this.items
      .map((item: any, i: number) => {
        if (!this.hasDelivery && i == 0) return;
        if (!this.hasBalcony && i == 1) return;
        if (!this.hasInternalDelivery && i == 2) return;
        return item;
      })
      .filter((item: any) => item != undefined);
  }
}
